var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',_vm._b({directives:[{name:"visible",rawName:"v-visible.once",value:(_vm.drawPage),expression:"drawPage",modifiers:{"once":true}}],ref:"canvasElm"},'canvas',_vm.canvasAttrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }